"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var list = window.location.search
    .substr(1)
    .split('&')
    .map(function (x) { return x.split('='); });
var params = new Map(list);
function getParam(name, def) {
    if (!params.has(name))
        return def;
    var value = params.get(name);
    if (typeof def === 'number')
        return parseFloat(value);
    return value;
}
exports.getParam = getParam;
function getParams(map, _a) {
    var _b = (_a === void 0 ? {} : _a).log, log = _b === void 0 ? false : _b;
    var result = {};
    Object.keys(map).forEach(function (key) {
        result[key] = getParam(key, map[key]);
    });
    if (log) {
        logParams(map, result);
    }
    return result;
}
exports.getParams = getParams;
function logParams(defaults, actual) {
    var entries = Object.keys(defaults)
        .map(function (x) { return "  - " + x + " = " + actual[x] + " (default: " + defaults[x] + ")"; })
        .join('\n');
    console.log("You can use URL parameters in this page. Avalable options with current values:\n" + entries);
}
